import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { API_URL } from "../../../utils/constant";
import CompanyMetalRateModal from "./company_metal_rate_modal";
import moment from "moment";
import { Pen, Trash } from "lucide-react";

const CompanyMetalRate = () => {
  const [rates, setRates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const company_id = localStorage.getItem("companyID");

  const fetchRates = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/company-metal-rates/company/${company_id}`
      );
      setRates(res.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchRates();
  }, []);

  const handleAdd = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This metal rate will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.delete(`${API_URL}/company-metal-rates/${id}`);
      Swal.fire("Deleted!", "Metal rate deleted successfully", "success");
      fetchRates();
    } catch (error) {
      Swal.fire("Error", "Failed to delete metal rate", "error");
    }
  };

  return (
    <div className="card" style={{ marginTop: "60px"}}>
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Company Metal Rates</h5>
        <button className="btn btn-primary" onClick={handleAdd}>
          + Add Metal Rate
        </button>
      </div>

      <div className="card-body">
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Effective From</th>
              <th>Gold Rate</th>
              <th>Silver Rate</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rates.length > 0 ? (
              rates.map((row) => (
                <tr key={row.id}>
                  <td>{moment(row.effective_from).format('DD, MMM YYYY')}</td>
                  <td>{row.gold}</td>
                  <td>{row.silver}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-warning me-2"
                      onClick={() => handleEdit(row)}
                    >
                      <Pen/>
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(row.id)}
                    >
                      <Trash/>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No metal rates found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <CompanyMetalRateModal
          show={showModal}
          heading={editData ? "Edit Metal Rate" : "Add Metal Rate"}
          initialData={editData}
          onClose={() => setShowModal(false)}
          onSuccess={fetchRates}
        />
      )}
    </div>
  );
};

export default CompanyMetalRate;
